import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/MenuLateral.css';
import { FaHome, FaCalendarAlt, FaUserShield, FaSignOutAlt } from 'react-icons/fa';
import { MdOutlinePendingActions, MdDensitySmall } from "react-icons/md";
import { CgInternal } from "react-icons/cg";

import logo from '../utils/sanfer-blanco.png'

const MenuLateral = ({ isMenuOpen }) => {
  const navigate = useNavigate();

  const handleCerrarSesion = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <nav className={`menu-lateral ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="menu-logo">
        <img src={logo} alt="Logo" />
      </div>
      <ul className="menu-list">
        <li>
          <Link to="/admin/"><FaHome className='icono-menu'/> Inicio</Link>
        </li>
        <li>
          <Link to="/admin/pendientes"> <MdOutlinePendingActions className='icono-menu'/> Pendientes</Link>
        </li>
        <li>
          <Link to="/admin/calendario"><FaCalendarAlt className='icono-menu'/> Calendario</Link>
        </li>
        <li>
          <Link to="/admin/todas"><MdDensitySmall className='icono-menu'/> Todas</Link>
        </li>
        <li>
          <Link to="/admin/reserva-interna"><CgInternal className='icono-menu'/> Reserva Interna</Link>
        </li>
        <li>
          <Link to="/admin/llegadas"><FaUserShield className='icono-menu'/> Llegadas</Link>
        </li>
      </ul>
      <div className="menu-logout">
        <button onClick={handleCerrarSesion} className="logout-btn">
          <FaSignOutAlt className='icono-menu'/> Cerrar Sesión
        </button>
      </div>
    </nav>
  );
};

export default MenuLateral;
